import { ReactNode } from "react";
import { Header, Paragraph } from "@datagame/ui";

import styles from "./Heading.module.scss";

interface HeadingProps {
  title: {
    main: string;
    marked: string;
  };
  children: ReactNode;
}

export const Heading = ({ title: { main, marked }, children }: HeadingProps) => (
  <>
    <Header variant="h5" className={styles.header}>
      {main}
      <span className={styles.orange}>{marked}</span>
    </Header>
    <Paragraph className={styles.description} color="secondary" size="small">
      {children}
    </Paragraph>
  </>
);
